$(document).on('mouseover', '.mh-nav__item', function(){
    $('.mh-context-menu__drop-down').removeClass('active');
});